<template>
	<div>
		<buttonlist @help="help" @search="search" @reflash="reflash" @exps="exps" ref="SetBtn"></buttonlist>
			<ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
			<li style="width: 100%; margin-top:0px" id="xpane-0">
				<vxe-table
						:data="dataSet"
						:highlight-current-row="true"
						resizable
						show-overflow="tooltip"
						:height="tableHeight"
						:loading="loading"
						header-row-class-name="headerclass"
						size="mini"
						border
						ref="singleTable1"
				>
					<vxe-table-column field="partcode" :title="$t('getapi[112]')" width="120"></vxe-table-column>
					<vxe-table-column field="partversion" :title="$t('getapi[149]')" width="120"></vxe-table-column>
					<vxe-table-column field="remain" :title="$t('getapi[7194]')" width="120" align="right"></vxe-table-column>
				</vxe-table>
			</li>
		</ul>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'2_mainsupplyremain',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3,
                maxHeight: this.$windowSize.tableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('2_suggestview'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			tableHeader: [],
            scrollTop:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.authority();
		that.colsort();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('mrpsuggest',0,PFileds=>{
			that.tableHeader=PFileds;		
		});	
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6600]"),'MRP');
        },
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('2_suggestview',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.getView()
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let parm = {}
			that.$http.urlpost('/MRP/CountView/GetMainSupplyDemandInfoRemain', parm, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent.Lists;
					that.loading = false;
				} else {
					that.$message.error(res.Msg);
				}
				that.authority();
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
		    let that = this
            let parm = {}
            that.$refs.SetBtn.SetOneBtnEnable('export', false);
            that.$http.urlpost('/MRP/CountView/MainSupplyDemandRemainToExcel', parm, function (res) {
                if (res.Success == 1) {
                    let hrefurl = Common.Url + res.DataContent.URL;
                    window.open(hrefurl);
                }
                that.$refs.SetBtn.SetOneBtnEnable('export', true);
            });
		},
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
